<template>
    <el-dialog :close-on-click-modal="false" visible width="35%" append-to-body :before-close="closeUpload">
        <div slot="title" class="title">
            <UploadTitleTips></UploadTitleTips>
        </div>
        <div class="GuidanceTooltip">
          <div class="guide-tip">
            <GuidanceTooltip
                :size='24'
                :content="$t('setFileAndDownloadTipHtml')"
                :jumpLink="$t('setFileAndDownloadTipLink')"
            ></GuidanceTooltip>
          </div>
          <div v-html="$t('split_file_tip')" class="guide-content-container"></div>
        </div>
        <el-upload
            class="upload-drag"
            ref="uploadPbc"
            :on-remove="handleRemove"
            :data="{ id: initData.id, siteId: getSite.siteId}"
            :disabled="initData.status == '4'"
            :headers="headers"
            :file-list="uploadFiles"
            :show-file-list="false"
            :limit="limitNum"
            :on-progress="uploading"
            :on-change="uploadChange"
            :on-success="handleAvatarSuccess"
            :on-exceed="handleExceed"
            :before-upload="beforeFileUpload"
            drag
            :action="actionUrl"
            :auto-upload="true"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" style="word-break: break-word;font-size: 14px">
                <em> {{$t('PAGE_PBC_UPLOAD_text1')}}{{ $t('PAGE_PBC_UPLOAD_text2') }}</em
                >
            </div>
            <div class="el-upload__tip upload-rule-text" style="color: #81848a">
                {{ $t('PAGE_PBC_UPLOAD_TIP', {size: 100}) }}
            </div>
        </el-upload>
        <!--    上传文件列表-->
        <div class="overflow-fileList-container"  v-if="uploadFiles.length" :style="{ height: (uploadFiles.length * 60) + 'px;'}">
            <div v-for="uploadFile in uploadFiles" :key="uploadFile.fileId" class="border-file" :style="{ height: uploadFile.status === 'uploading' && uploadFile.percentage !== 100 ? '55px;' : '40px;'}">
                <div class="uploaded-cls" :title="uploadFile.name">
                    <svg-icon :icon-name="getUploadFileIcon(uploadFile.name)" :size="24" style="margin-left: 10px;"></svg-icon>
                    <span class="upload-filename" >{{ uploadFile.name }}</span>
                    <div v-if="uploadFile.status === 'success'" style="margin-right: 10px;margin-left: auto;display: grid;grid-template-columns: 1fr 1fr;">
                        <!--            已接受条目不可删除 || 毕马威不可删除客户上传的文件 || 客户也不可删除毕马威上传的文件 -->
                        <!--<i
                            class="el-icon-circle-check"
                            v-if="initData.status == '4' || noAuthority(uploadFile)"
                            style="color: rgb(103, 194, 58)"
                        ></i>-->
                        <template>
                            <svg-icon icon-name="upload-success" :size="16" style="margin-right: 5px;"></svg-icon>
                            <div @click="handleRemove(uploadFile)"><svg-icon icon-name="upload-delete" :size="16" ></svg-icon></div>
                        </template>
                    </div>
                    <div style="position: relative;margin-right: 18px;margin-left: auto;" class="progress-cls" v-if="uploadFile.status === 'uploading'">
                        <i v-if="uploadFile.percentage === 100" class="el-icon-loading loading-cls"/>
                        <div @click="removeUploading(uploadFile)"><svg-icon icon-name="upload-delete" :size="16" ></svg-icon></div>
                    </div>
                </div>
                <el-progress
                    v-if="uploadFile.status === 'uploading' && uploadFile.percentage !== 100"
                    :percentage="parseInt(uploadFile.percentage)"
                    :stroke-width="3"
                    :format="formatProgress"
                    style="width: 100%;"
                ></el-progress>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeUpload" class="btn cancel-btn">{{
                $t('btn_close')
            }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import API from '@/api'
import { checkIsValidExtension } from '@/utils/fileType'
import requestUrl from '@/api/requestUrl'
import { mapGetters } from 'vuex'
import UploadTitleTips from '@/components/common/UploadTitleTips.vue'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import SvgIcon from "@/components/svgIcon/index";
import { getFileIcon } from '../components/data.js'

export default {
    data() {
        return {
            headers: {},
            actionUrl: requestUrl('/client/pbcGroup/uploadPbcFiles'),
            params: new FormData(),
            // fileList: [],
            timer: null,
            notify: null,
            uploadFiles: [],
            timer1: null,
            timer2: null,
            timer3: null,
            scrollTimer: null,
        }
    },
    computed: {
        limitNum() { // 限制文件数为0的时候还可以上传，因此赋值为-1
            if(this.initData.fileNameList.length >= 100) {
                return -1
            } else {
                return 100 - this.initData.fileNameList.length
            }
        },
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite',
        })
    },
    methods: {
        noAuthority(file) {
            return (
                (file.uploadBy && file.uploadBy.indexOf('@') === -1 && this.getUser.userType === '2') ||
                (file.uploadBy && file.uploadBy.indexOf('@') != -1 && this.getUser.userType === '1')
            )
        },
        uploading(event, file, files) {
            if (event.percent === 100 && this.notify == null) {
                this.notify = this.$message.warning({
                    message: this.$t('upload_file_valid'),
                    duration: 0,
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    onClose: () => {
                        this.notify = null
                    }
                })
            }
        },
        uploadChange(file, files) {
            if (file.status === 'success') {
                // 上传成功后，判断uploadFiles中有没有与当前上传文件同名的，有则删除
                let index = this.uploadFiles.findIndex((item) => item.name === file.name && item.uid !== file.uid)
                if (index != -1) {
                    this.uploadFiles.splice(index, 1)
                }
            } else if(file.status !== 'fail') {
                this.uploadFiles.unshift(file)
            } else {
                // 上传失败，删除失败文件
                this.$message.error(file.name + this.$t('file_upload_failed'))
                let index = this.uploadFiles.findIndex((item) => item.name === file.name && item.uid === file.uid)
                if (index != -1) {
                    this.uploadFiles.splice(index, 1)
                }
            }
            if (this.uploadFiles.every((item) => item.status === 'success' || item.status === 'fail') && this.notify !== null) {
                this.notify.close()
                this.notify = null
            }
        },
        formatProgress(percentage) {
            return percentage === 100 ? '' : `${percentage}%`
        },
        handleAvatarSuccess(res, file, files) {
            if (res.code == '1') {
            } else {
                this.$message.error(this.$t(res.code))
                let index = this.uploadFiles.findIndex((item) => item.name === file.name && item.uid === file.uid)
                if (index != -1) {
                    this.uploadFiles.splice(index, 1)
                }
            }
            this.params = new FormData()
        },
        beforeFileUpload(file) {
            if(!this.scrollTimer) clearTimeout(this.scrollTimer)
            this.scrollTimer = setTimeout(() => {
                let overflow = document.querySelector('.overflow-fileList-container')
                overflow.scrollTop = 0
            }, 100)
            const isJPG = checkIsValidExtension(file.name)
            const isLt1G = file.size / 1024 / 1024 / 1024 < 1
            // 有50个不重名的文件则提示超出限制
            let uniqueNameFileList = []
            this.uploadFiles.forEach((v, k) => {
                if (!uniqueNameFileList.find((vv) => vv == v.name)) {
                    uniqueNameFileList.push(v.name)
                }
            })
            const isFileList = (this.initData.fileNameList.length + uniqueNameFileList.length) <= 100
            if (!isJPG) {
                clearTimeout(this.timer1)
                this.timer1 = setTimeout(() => {
                    this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_TYPE'))
                }, 100)
            } else if (!isLt1G) {
                clearTimeout(this.timer2)
                this.timer2 = setTimeout(() => {
                    this.$message.error(this.$t('PAGE_PBC_UPLOAD_SIZE'))
                }, 100)
            } else if (!isFileList) {
                clearTimeout(this.timer3)
                this.timer3 = setTimeout(() => {
                    this.$message.error(this.$t('PAGE_PBC_UPLOAD_LIMIT', {size: 100}))
                }, 100)
            }
            // 移除不符合上传规则的文件
            if (!isJPG || !isLt1G || !isFileList) {
                let index = this.uploadFiles.findIndex(item => item.uid === file.uid)
                this.uploadFiles.splice(index, 1)
            }
            return isJPG && isLt1G && isFileList
        },
        handleRemove(file, fileList) {
            if (file.status == 'success') {
                let fileId = file.fileId || file.response.data.uploadDocumentInfo.id
                const params = {
                    fileId: fileId,
                    id: this.initData.id,
                    fileNameList: [file.name],
                    source: 'pbc',
                    ifDeleteHistory: true,
                    siteId: this.getSite.siteId
                }
                this.$confirm(this.$t('FILE_DELETE_WARNING_MSG'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        // 删除----
                        API.pbc.deletePbcFiles(params).then((res) => {
                            if (res.code != '1') {
                                return false
                            } else if (res.code == '1') {
                                let index = this.uploadFiles.findIndex((item) => item.uid === file.uid)
                                this.uploadFiles.splice(index, 1)
                            }
                        })
                    })
                    .catch(() => {})
            }
        },
        removeUploading(file) {
            this.$refs.uploadPbc.abort(file)
            let index = this.uploadFiles.findIndex((item) => item.uid === file.uid)
            this.uploadFiles.splice(index, 1)
            if (this.uploadFiles.every((item) => item.status === 'success' || item.status === 'fail') && this.notify !== null) {
                this.notify.close()
                this.notify = null
            }
        },
        handleExceed(files, fileList) {
            //  
            this.$message.error(this.$t('PAGE_PBC_UPLOAD_LIMIT', {size: 100}))
        },
        /*onConfirm() {
            // 有50个不重名的文件则提示超出限制
            let uniqueNameFileList = []
            this.fileList.forEach((v, k) => {
                if (!uniqueNameFileList.find((vv) => vv == v.name)) {
                    uniqueNameFileList.push(v.name)
                }
            })
            if (uniqueNameFileList.length > 50) {
                this.$message.error(this.$t('PAGE_PBC_UPLOAD_LIMIT'))
                return false
            }

            this.$refs.uploadPbc.submit()
        },*/
        closeUpload() {
             
            let uploadingFiles = this.uploadFiles.filter(item => item.status === 'ready' || item.status === 'uploading')
            if (uploadingFiles.length > 0) {
                this.$confirm(this.$t('BEFORE_CLOSE_WARING_MSG'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.uploadFiles.forEach((item) => {
                        if(item.status === 'ready' || item.status === 'uploading') {
                            this.$refs.uploadPbc.abort(item)
                        }
                    })
                    this.onCancel()
                })
            } else {
                this.onCancel()
            }
        },
        getUploadFileIcon(filename) {
          return getFileIcon(filename);
        },
    },
    components: { UploadTitleTips, GuidanceTooltip ,SvgIcon},
    mounted() {
        this.headers = {
            Authorization: sessionStorage.getItem('JSESSIONID'),
            siteClassification: sessionStorage.getItem('siteClassification')
        }
    },
    props: {
        onCancel: Function,
        saveLoading: Boolean,
        initData: [String, Object],
        show: Boolean
    },
    beforeDestroy() {
        if (this.notify !== null) {
            this.notify.close()
            this.notify = null
        }
        if(this.scrollTimer) clearTimeout(this.scrollTimer)
    },
}
</script>
<style scoped>
.title {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.title .GuidanceTooltip {
    margin-left: 10px;
}
.GuidanceTooltip {
    display: flex;
    flex-direction: row;
    align-items: flex-start;;
    margin: 15px 0 15px;
}
::v-deep .el-dialog__body {
    padding: 20px;
    padding-top: 0px;
}
.upload_tip {
    color:#fd349c;
    font-size: 12PX;
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
}
.upload-drag {
    width: 100%;
}
::v-deep .upload-drag .el-upload-list {
    overflow: auto;
    max-height: 40vh;
}
::v-deep .el-upload--text .el-upload-dragger{
    height: auto;
    padding: 20px;
    border-color: #4290f7;
}
::v-deep .el-upload--text .el-upload-dragger .el-icon-upload {
    font-size: 50px;
    color: #3879eb;
    margin: 15px 0 15px;
    line-height: 50px;
}
.upload-rule-text{
    padding: 15PX 25PX;
    color: #81848a;
    margin-bottom: 15PX;
    font-size: 12PX;
}
.loading-cls{
    position: absolute;
    right: 24px;
    top: 0;
    color: rgb(64, 158, 255);
    cursor: pointer;
    font-size: 14px;
}
.del-cls{
    position: absolute;
    right: 0;
    top: 0;
    color: #fd349c;
    cursor: pointer;
    font-size: 14px;
}
.uploaded-cls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    high: 40px;
    font-size: 14px;
}
.del-uploaded-cls {
    color: #fd349c;
    margin-left: 10px;
    font-size: 14px;
    cursor: pointer;
}
.uploaded-cls:hover {
    background-color: rgba(230, 230, 230, 0.5);
}
.uploaded-cls:hover .del-uploaded-cls {
    display: inline-block;
}
.overflow-fileList-container{
    max-height: 30vh;
    overflow: auto;
    display: grid;
    --grid-template-columns: 1fr 1fr;
    gap: 10px 5px;
    margin-top: 10px;
    transition: height 0.5s ease;
}
.guide-content-container{
    font-size: 12PX;
    margin-right: 30px;
}
.guide-tip{
    background: #00b8f5;
    border-radius: 5px;
    width: 24px;
    height: 24px;
    text-align: center;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.border-file {
    box-sizing: border-box;
    background: #F5F8FB;
    border-radius: 5px;
    width: 98%;
}
.upload-filename {
    margin-left: 10px;
    width:70%;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
}

</style>
